import React from 'react';
import UserRoleRow from './UserRoleRow';
import FilterableTable from '../filters/FilterableTable';

const UserRoleTable = ({
  dispatch,
  userRoleReducer,
  findAllUserRolesPageble,
  updateUserRole,
  deleteUserRole,
  clearValidationErrors,
}) => {
  const { userRoleList, totalElements } = userRoleReducer;

  let roleNameList = userRoleList.map((role, index) => (
    <UserRoleRow
      key={role.id}
      role={role}
      deleteUserRole={deleteUserRole}
      updateUserRole={updateUserRole}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      userRoleReducer={userRoleReducer}
    />
  ));

  const columns = [
   
    {
      id: 'Uloga',
      name: 'Uloga',
      filter: {
        field: 'roleName',
        value: '',
        type: 'LIKE',
      },
    },
    { id: 'Измена', name: 'Измена' },
    { id: 'Брисање', name: 'Брисање' },
  ];

  return (
    <>
      <FilterableTable
        tableStyle="table-container-with-row-below"
        columns={columns}
        action={findAllUserRolesPageble}
        rows={roleNameList}
        totalElements={totalElements}
        filterPosition
      ></FilterableTable>
    </>
  );
};

export default UserRoleTable;
